import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NightLifeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NightLifeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.7026 22C7.91319 22 4.82994 18.9167 4.82994 15.1263C4.82994 11.3369 7.91319 8.25367 11.7026 8.25367C15.492 8.25367 18.5753 11.3369 18.5753 15.1263C18.5753 18.9167 15.492 22 11.7026 22ZM11.7026 9.25662C8.46608 9.25662 5.83288 11.8893 5.83288 15.1264C5.83288 18.3634 8.46608 20.9971 11.7026 20.9971C14.9391 20.9971 17.5723 18.3634 17.5723 15.1264C17.5723 11.8893 14.9391 9.25662 11.7026 9.25662Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7026 22C11.4254 22 11.2011 21.7757 11.2011 21.4985V8.75515C11.2011 8.47797 11.4254 8.25367 11.7026 8.25367C11.9798 8.25367 12.2041 8.47797 12.2041 8.75515V21.4985C12.2041 21.7757 11.9798 22 11.7026 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7026 22C11.5293 22 11.3613 21.9099 11.2687 21.7483C11.1306 21.5083 11.2134 21.2027 11.4524 21.0637C11.5782 20.9912 14.5356 19.2311 14.5356 15.1273C14.5356 11 11.4847 9.20764 11.4539 9.19098C11.2134 9.05287 11.1297 8.74631 11.2673 8.50635C11.4044 8.26639 11.7119 8.18412 11.9514 8.31928C12.0978 8.40351 15.5386 10.4241 15.5386 15.1273C15.5386 19.8296 12.0978 21.8501 11.9514 21.9344C11.8731 21.9784 11.7868 22 11.7026 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7026 22C11.6184 22 11.5322 21.9785 11.4538 21.9344C11.3074 21.8502 7.86667 19.8296 7.86667 15.1273C7.86667 10.4241 11.3074 8.40353 11.4538 8.31929C11.6943 8.18413 11.9984 8.26542 12.1365 8.50539C12.2746 8.74535 12.1918 9.05094 11.9528 9.19001C11.827 9.2625 8.86959 11.0225 8.86959 15.1273C8.86959 19.2537 11.9205 21.046 11.9514 21.0627C12.1918 21.2008 12.2756 21.5073 12.138 21.7473C12.0454 21.9089 11.8765 22 11.7026 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0738 15.6278H5.33141C5.05423 15.6278 4.82994 15.4035 4.82994 15.1263C4.82994 14.8492 5.05423 14.6249 5.33141 14.6249H18.0738C18.351 14.6249 18.5753 14.8492 18.5753 15.1263C18.5753 15.4035 18.351 15.6278 18.0738 15.6278Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4808 12.9491H5.92593C5.64875 12.9491 5.42446 12.7248 5.42446 12.4476C5.42446 12.1704 5.64875 11.9461 5.92593 11.9461H17.4808C17.758 11.9461 17.9822 12.1704 17.9822 12.4476C17.9822 12.7248 17.758 12.9491 17.4808 12.9491Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4808 18.3075H5.92593C5.64875 18.3075 5.42446 18.0833 5.42446 17.8061C5.42446 17.5289 5.64875 17.3046 5.92593 17.3046H17.4808C17.758 17.3046 17.9822 17.5289 17.9822 17.8061C17.9822 18.0833 17.758 18.3075 17.4808 18.3075Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3696 9.48482H10.0351C9.75795 9.48482 9.53366 9.26053 9.53366 8.98335V6.07639C9.53366 5.79921 9.75795 5.57492 10.0351 5.57492H13.3696C13.6468 5.57492 13.8711 5.79921 13.8711 6.07639V8.98335C13.8711 9.26053 13.6468 9.48482 13.3696 9.48482ZM10.5366 8.48188H12.8681V6.57786H10.5366V8.48188Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7036 6.57786C11.4264 6.57786 11.2021 6.35357 11.2021 6.07639V3.30754C11.2021 3.03036 11.4264 2.80607 11.7036 2.80607C11.9808 2.80607 12.2051 3.03036 12.2051 3.30754V6.07639C12.2051 6.35357 11.9808 6.57786 11.7036 6.57786Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0738 10.2135C17.8319 10.2135 17.6243 10.0411 17.5807 9.80313C17.2653 8.09108 17.1453 7.97061 15.4328 7.65524C15.1948 7.61116 15.0224 7.40352 15.0224 7.1616C15.0224 6.91968 15.1953 6.71204 15.4333 6.66797C17.1448 6.35356 17.2653 6.2331 17.5807 4.52106C17.6243 4.28306 17.8319 4.11067 18.0738 4.11067C18.3157 4.11067 18.5234 4.28306 18.567 4.52106C18.8823 6.2331 19.0028 6.35357 20.7144 6.66797C20.9524 6.71204 21.1252 6.91968 21.1252 7.1616C21.1252 7.40352 20.9529 7.61116 20.7149 7.65524C19.0023 7.97061 18.8823 8.09108 18.567 9.80313C18.5234 10.0411 18.3157 10.2135 18.0738 10.2135ZM17.2839 7.1616C17.636 7.35259 17.8838 7.60039 18.0738 7.95201C18.2638 7.60039 18.5116 7.35259 18.8637 7.1616C18.5116 6.97159 18.2638 6.7238 18.0738 6.37218C17.8838 6.7238 17.636 6.97159 17.2839 7.1616Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.92593 8.10284C5.68401 8.10284 5.47637 7.93045 5.43279 7.69246C5.11741 5.98041 4.99694 5.85994 3.28539 5.54555C3.04739 5.50147 2.87451 5.29383 2.87451 5.05191C2.87451 4.80999 3.04738 4.60235 3.28489 4.55827C4.99694 4.2429 5.11741 4.12243 5.43279 2.41038C5.47637 2.17239 5.68401 2 5.92593 2C6.16785 2 6.37549 2.17239 6.41908 2.41038C6.73445 4.12243 6.85443 4.2429 8.56697 4.55827C8.80496 4.60235 8.97735 4.80999 8.97735 5.05191C8.97735 5.29383 8.80448 5.50147 8.56648 5.54555C6.85492 5.85995 6.73445 5.98041 6.41908 7.69246C6.37549 7.93045 6.16785 8.10284 5.92593 8.10284ZM5.13651 5.05191C5.48813 5.24192 5.73592 5.48971 5.92593 5.84133C6.11594 5.48971 6.36373 5.24192 6.71584 5.05191C6.36374 4.86092 6.11595 4.61313 5.92593 4.26151C5.73592 4.6141 5.48813 4.86092 5.13651 5.05191Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NightLifeIcon;
